export default "__VITE_ASSET__BHrvbykk__"